// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackCircleFilledSvg from "@ant-design/icons-svg/es/asn/SlackCircleFilled";
import AntdIcon from '../components/AntdIcon';

var SlackCircleFilled = function SlackCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackCircleFilledSvg
  }));
};

SlackCircleFilled.displayName = 'SlackCircleFilled';
export default React.forwardRef(SlackCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SlackCircleFilled.js
// module id = 1821
// module chunks = 0